import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './home/home.component';

import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import {MatExpansionModule} from '@angular/material/expansion';

import { ReviewsComponent } from './reviews/reviews.component';
import { FormComponent } from './form/form.component';
import { NavbarComponent } from './navbar/navbar.component';
import { BgSectionComponent } from './bg-section/bg-section.component';
import { OffersAccordionComponent } from './offers-accordion/offers-accordion.component';
import { FormPageComponent } from './form-page/form-page.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { CtasComponent } from './ctas/ctas.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CardStatsComponent } from './card-stats/card-stats.component';
import { BrandsComponent } from './brands/brands.component';
import { FooterComponent } from './footer/footer.component';
import { LocationComponent } from './location/location.component';
import { HoverMenuComponent } from './hover-menu/hover-menu.component';
import { OffersPageComponent } from './offers-page/offers-page.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ConvenzioniComponent } from './convenzioni/convenzioni.component';
import { SinistriComponent } from './sinistri/sinistri.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {HttpClientModule} from '@angular/common/http';
import { TassaAutoComponent } from './tassa-auto/tassa-auto.component';
import { SanitariaComponent } from './sanitaria/sanitaria.component';
import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { GDPRComponent } from './gdpr/gdpr.component';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { AzzeramentoFranchigiaComponent } from './azzeramento-franchigia/azzeramento-franchigia.component';
import { HomeArticleComponent } from './home-article/home-article.component';

const cookieConfig:NgcCookieConsentConfig = {
  cookie: {
    domain: 'francaviglia-assicurazioni.it'
  },
  palette: {
    popup: {
      background: '#000'
    },
    button: {
      background: '#2C626F'
    }
  },
    content: {
      message: "Questo Sito utilizza cookie per migliorare l’esperienza di navigazione degli utenti e per raccogliere informazioni sull’utilizzo del sito stesso. Facendo clic su \"Accetto\", accetti il ​​nostro utilizzo di cookie. Se desideri avere maggiori informazioni, puoi consultare la ",
      link: "Cookie Policy",
      allow: "Accetto",
      deny: "Esci dal sito",
      href: "/cookiePolicy"
    },
  theme: 'edgeless',
  type: 'opt-out'
};

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: "enabled",
  anchorScrolling: "enabled",
  scrollOffset: [0, 64]
}
const appRoutes: Routes = [
  { path: 'contatti', component: FormPageComponent },
  { path: 'prodotti', component: OffersPageComponent },
  { path: 'termsOfService', component: PrivacyComponent },
  { path: 'convenzioni', component: ConvenzioniComponent },
  { path: 'sinistri', component: SinistriComponent },
  { path: 'tassaAuto', component: TassaAutoComponent },
  { path: 'coperturaSanitaria', component: SanitariaComponent },
  { path: 'cookiePolicy', component: CookiePolicyComponent },
  { path: 'GDPR', component: GDPRComponent },
  { path: 'newsletter', component: NewsletterComponent },
  { path: 'franchigie', component: AzzeramentoFranchigiaComponent },
  { path: '', component: HomeComponent },
  { path: '**', component: PageNotFoundComponent },
  
];
export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ReviewsComponent,
    FormComponent,
    NavbarComponent,
    BgSectionComponent,
    OffersAccordionComponent,
    FormPageComponent,
    PageNotFoundComponent,
    CtasComponent,
    CardStatsComponent,
    BrandsComponent,
    FooterComponent,
    LocationComponent,
    HoverMenuComponent,
    OffersPageComponent,
    PrivacyComponent,
    ConvenzioniComponent,
    SinistriComponent,
    TassaAutoComponent,
    SanitariaComponent,
    CookiePolicyComponent,
    GDPRComponent,
    NewsletterComponent,
    AzzeramentoFranchigiaComponent,
    HomeArticleComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatSidenavModule,
    HttpClientModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    RouterModule.forRoot(
      appRoutes, routerOptions),
    MatSnackBarModule,
    LottieModule.forRoot({
      player: playerFactory,
      useCache: true }),
      CarouselModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
